export const environment = {
  production: true,
  // Local wordpress Test
  // elastic_url_search: '/assets/api/elastic.php',
  // elastic_url_document: '/assets/api/elastic-document79.php'
  // Server Test
  elastic_url_search: '/wp-content/themes/graphy/app/assets/api/elastic.php',
  // elastic_url_document: '/wp-content/themes/understrap-child/app/assets/api/elastic-document79.php',

  elastic_url_document: '/wp-content/themes/graphy/app/assets/api/elastic-document.php',
  elastic_url_doctyp4: '/wp-content/themes/graphy/app/assets/api/elastic-doctyp4.php',
  elastic_url_doctyp3: '/wp-content/themes/graphy/app/assets/api/elastic-doctyp3.php',
  elastic_url_doctyp5: '/wp-content/themes/graphy/app/assets/api/elastic-doctyp5.php',
  elastic_url_analyse: '/wp-content/themes/graphy/app/assets/api/elastic-analyse.php'
  // elastic_url: '/wp-content/themes/understrap-child/app/backend/elastic.php'
};
